import {
  TABLE_EXPORT_COLUMNS_SCOPE,
  TABLE_EXPORT_ROWS,
  TableExportColumnsScope,
  TableExportRows,
} from 'models/TableExport';

export function getTableExportRowsAndColumnsParams({
  rows,
  columnsScope,
  columns,
  page,
  limit,
}: {
  rows: TableExportRows;
  columnsScope: TableExportColumnsScope;
  columns: string[];
  page: string;
  limit: string;
}) {
  return {
    ...(rows === TABLE_EXPORT_ROWS.PAGE && { $page: page, $limit: limit }),
    ...(columnsScope === TABLE_EXPORT_COLUMNS_SCOPE.VISIBLE && { columns }),
  };
}
